import { render } from "./CameraItem.vue?vue&type=template&id=210e77cc&ts=true"
import script from "./CameraItem.vue?vue&type=script&lang=ts"
export * from "./CameraItem.vue?vue&type=script&lang=ts"

import "./CameraItem.vue?vue&type=style&index=0&id=210e77cc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__